import React from 'react';
import { EmailStatusCode } from 'areas/shared/consts';

class EmailStatusLabel extends React.Component {
	render() {
		var styleDiv={
			display: 'inline-block',
			padding: '.2em .6em .3em',
			fontSize: '85%',
			fontWeight: '700',
			lineHeight: '1',
			color: 'white',
			textAlign: 'center',
			whiteSpace: 'nowrap',
			verticalAlign: 'baseline',
			borderRadius: '.25em',
			width: '6em'
		};

		var v = this.props.emailStatusCode.toUpperCase();
		let s = '#777777';

		if (v === EmailStatusCode.SENT)
			s = 'blue';
		else if (v === EmailStatusCode.QUEUED)
			s = 'purple';
		else if (v === EmailStatusCode.ERROR)
			s = 'red';
		else if (v === EmailStatusCode.DELIVERED)
			s = 'green';
		else if (v === EmailStatusCode.BOUNCED)
			s = 'orange';

		return (
			// Using a DIV instead of LABEL let us control the width...
			<div className={this.props.className} style={{...styleDiv, backgroundColor: s}}>
					{v}
			</div>	
		);
	}
}

export default EmailStatusLabel;


// WEBPACK FOOTER //
// ./src/areas/shared/controls/emailStatusLabel/EmailStatusLabel.js